export default __webpack_public_path__ + "static/media/CSS3.603d99c8.jpeg";